import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHastalar } from '../services/api';

export default function HastaAra() {
  const [aramaMetni, setAramaMetni] = useState('');
  const [hastalar, setHastalar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [aramaDeneme, setAramaDeneme] = useState(false);
  const navigate = useNavigate();

  const ara = async (e) => {
    e.preventDefault();
    if (!aramaMetni.trim()) return;
    setYukleniyor(true);
    setAramaDeneme(true);
    try {
      const res = await getHastalar(aramaMetni);
      setHastalar(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: 14, fontWeight: 600, marginBottom: 16 }}>Hasta Ara</h2>

      {/* Arama Formu */}
      <div className="card" style={{ marginBottom: 16 }}>
        <form onSubmit={ara} style={{ display: 'flex', gap: 10 }}>
          <input
            type="text"
            placeholder="Ad, soyad veya telefon ile arayın..."
            value={aramaMetni}
            onChange={e => setAramaMetni(e.target.value)}
            style={{ flex: 1 }}
          />
          <button type="submit" className="btn btn-primary" disabled={yukleniyor}>
            {yukleniyor ? '...' : '🔍 Ara'}
          </button>
        </form>
      </div>

      {/* Sonuçlar */}
      {aramaDeneme && (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {yukleniyor ? (
            <div className="loading">Aranıyor...</div>
          ) : hastalar.length === 0 ? (
            <div className="empty">Sonuç bulunamadı</div>
          ) : (
            <>
              <div style={{ padding: '8px 16px', background: '#f8faf9', borderBottom: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)' }}>
                {hastalar.length} hasta bulundu
              </div>
              {hastalar.map(h => (
                <div key={h.kayitNo}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', borderBottom: '1px solid var(--border)', cursor: 'pointer', transition: 'background 0.1s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8faf9'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  onClick={() => navigate(`/hasta/${h.kayitNo}`)}
                >
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'var(--med-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, color: 'var(--med-dark)', flexShrink: 0 }}>
                    {h.hesapAdi?.split(' ').map(n => n[0]).join('').slice(0, 2)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, fontSize: 13 }}>{h.hesapAdi}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                      #{h.kayitNo} · {h.tcKimlik} · {h.cinsiyet} · {h.dogTar}
                    </div>
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--med-accent)' }}>›</div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
}
